module.exports = __webpack_public_path__ + "static/media/testimonies-header.b800c00d.jpg";